import React from 'react'
import bdLogo from '../../../public/Bitmap.png'
import lostLogo from '../../../public/LostCards.svg'

function NotFound() {
  return (
    <div className='not-found-container'>
      <div className='nav-bar'>
        <a
          href='https://branding.cards'
          alt='bd-logo'
          className='bd-logo-container'
        >
          <img className='bd-logo' src={bdLogo} alt='Brand Deck Logo' />
        </a>
        <div className='back-link-container'>
          <a className='back-link' href='https://branding.cards'>
            Back to Branding.Cards
          </a>
        </div>
      </div>
      <div className='not-found-render'>
        <div className='not-found-header'>404 Not Found</div>
        <img className='not-found-image' src={lostLogo} alt='LostLogos' />
        <div className='not-found-text'>
          <div>Oops, that page doesn't seem to exist</div>
          <a className='bd-link' href='https://app.branding.cards'>
            Go Home
          </a>
        </div>
      </div>
    </div>
  )
}

export default NotFound
